import React from "react";

const objectivesData = [
  {
    title: "Course Objectives:",
    items: [
      "Provide advanced knowledge of international relations, diplomatic principles, and global governance systems.",
      "Develop strategic thinking and critical analysis skills to address geopolitical challenges.",
      "Cultivate superior negotiation, mediation, and conflict resolution capabilities for high-stakes diplomatic scenarios.",
      "Foster cross-cultural communication and collaboration skills essential for global diplomacy.",
      "Equip participants to evaluate and shape foreign policies and international agreements.",
    ],
    color: "text-green-600",
  },
  {
    title: "Course Outcomes:",
    items: [
      "Demonstrate a comprehensive understanding of international relations theories and their application to global diplomatic practices.",
      "Apply advanced diplomatic strategies to resolve complex international challenges.",
      "Exhibit proficiency in negotiation and mediation, leveraging cultural intelligence and strategic foresight.",
      "Critically analyse foreign policies and global political trends to propose actionable solutions.",
      "Communicate and collaborate effectively with diverse stakeholders in international settings.",
    ],
    color: "text-purple-600",
  },
];

const ObjectivesAIR = () => {
  return (
    <div className="my-10 " id="objectives">
      <div className="max-w-6xl mx-auto bg-sdbodywhiteywhitebodyywhitebodyywhitebodyywhitebodyywhitebody bg-opacity-70 shadow-lg rounded-lg p-8">

        <div className="md:flex md:gap-8 space-y-5 md:space-y-0">
          {objectivesData.map((section, index) => (
            <div key={index} className="md:w-1/2">
              <h3
                className={`text-lg md:text-2xl font-semibold mb-4 ${section.color}`}
              >
                {section.title}
              </h3>
              <ul className="space-y-4 list-disc list-inside">
                {section.items.map((item, idx) => (
                  <li key={idx} className="flex items-start gap-4">
                    <img
                      src="/image-fix/pointers/inspiration-svgrepo-com.svg"
                      alt="icon"
                      className="w-8 h-8 mt-1"
                    />
                    <span className="text-base">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ObjectivesAIR;
